import { useQuery } from "@tanstack/react-query";
import { RelabelCaseService } from "src/services/relabelCases";
import { queryKeys } from "src/constants";

const useCompleteCases = (relabelCaseService: RelabelCaseService) => {
  const {
    data: completeCasesData,
    isLoading,
    error: fetchError,
    refetch: refreshCompleteCases
  } = useQuery({
    queryKey: queryKeys.completeCases(),
    queryFn: () => relabelCaseService.getCompleteCases({ limit: 500 })
  });

  return {
    completeCases: completeCasesData?.items ?? [],
    isLoading,
    fetchError,
    refreshCompleteCases
  };
};

export { useCompleteCases };
